import * as React from 'react';
import { Paragraph2 } from '@cian/ui-kit/typography';

import { Tabs } from '../../../../Tabs';
import { IFilterProps } from '../../types';

import * as styles from './styles.css';

export const Filter: React.FC<IFilterProps> = props => {
  const { items, activeIDs, onClick, title } = props;

  return (
    <div className={styles['filter']}>
      {title && (
        <div className={styles['filter-title']}>
          <Paragraph2>{props.title}</Paragraph2>
        </div>
      )}
      <Tabs items={items} activeIDs={activeIDs} onClick={onClick} />
    </div>
  );
};

Filter.displayName = 'Filter';
